import { render } from "./InsiteIndex.vue?vue&type=template&id=bfe3cdf6"
import script from "./InsiteIndex.vue?vue&type=script&lang=js"
export * from "./InsiteIndex.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__